/**
 * @module support/state-object-hash-utilities
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Injectable } from '@angular/core';
import * as objectHash from 'object-hash';
import * as objectPath from 'object-path';

@Injectable()
export class HashService {
  constructor() {}

  /**
   * maskRequest - masks elements in object that are specified by paths in mask array and returns
   *
   * @param {Object} req
   * @param {Array<Object>} mask
   * @returns {Object}
   *
   * @memberOf HashService
   */
  public maskRequest(req: Object, mask: Object[]): Object {
    const result = JSON.parse(JSON.stringify(req));

    while (mask.length) {
      const element = mask.pop();
      objectPath.del(result, element);
    }
    return result;
  }

  /**
   * hashRequest - returns the hash string specified by requested masked Object
   *
   * @param {Object} req
   * @param {Array<Object>} mask
   * @returns string
   *
   * @memberOf HashService
   */
  public hashRequest(req: Object, mask?: Object[]): string {
    if (mask) {
      return objectHash(this.maskRequest(req, mask));
    } else {
      return objectHash(req);
    }
  }
}
